/* The Hollow Harvest · la mappa del villaggio
   I punti sulla veduta e le righe dell'elenco accanto condividono lo stesso
   data-index: selezionare l'uno accende lo stesso stato sull'altro, che sia
   il mouse, il dito o la tastiera a farlo. Sono tutti bottoni veri: se lo
   script non parte restano cliccabili via aria-label e l'elenco resta testo
   normale, sempre leggibile.

   Sul punto (anonimo finché non lo tocchi) il primo tocco col dito apre il
   cartiglio e basta, il secondo apre la battlemap. Sulla riga dell'elenco,
   che mostra già nome e riga di canone, un solo tocco apre la battlemap: non
   c'è nulla da rivelare per primo.

   Le battlemap si scaricano solo quando qualcuno le apre. */

(function () {
  'use strict';

  function init(root) {
    var spots = Array.prototype.slice.call(root.querySelectorAll('.hh-spot'));
    var items = Array.prototype.slice.call(root.querySelectorAll('.hh-village__item'));
    if (!spots.length && !items.length) return;

    // col dito non esiste il passaggio del mouse
    var touch = window.matchMedia('(hover: none)').matches;

    var box = document.createElement('div');
    box.className = 'hh-lightbox';
    /* Marcata: in pagina esiste anche la lente delle tavole, con la stessa
       classe. Senza questo segno apreMappaIntera prendeva la prima delle due,
       cioe' una a caso a seconda di quale script arrivava per primo. */
    box.setAttribute('data-hh-map-lightbox', '');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.hidden = true;
    box.innerHTML =
      '<button class="hh-lightbox__close" type="button" aria-label="Close">&#215;</button>' +
      '<figure class="hh-lightbox__figure"><img alt=""><figcaption></figcaption></figure>';
    document.body.appendChild(box);

    var img = box.querySelector('img');
    var cap = box.querySelector('figcaption');
    var lastFocused = null;

    function closeLightbox() {
      box.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { box.hidden = true; if (lastFocused) lastFocused.focus(); }, 240);
    }

    function openLightbox(trigger) {
      var map = trigger.getAttribute('data-map');
      if (!map) return;
      lastFocused = trigger;
      img.src = map;
      img.alt = trigger.getAttribute('data-name') || '';
      cap.textContent = trigger.getAttribute('data-name') + '. ' + (trigger.getAttribute('data-line') || '');
      box.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { box.classList.add('is-open'); });
      box.querySelector('.hh-lightbox__close').focus();
    }

    // stato selezionato condiviso: un solo indice acceso alla volta, sia sul
    // punto che sulla riga corrispondente. E' anche l'unico segno ember
    // attivo in quel momento sulla sezione: non ce n'e' mai piu' di uno.
    function select(index) {
      spots.forEach(function (s) {
        var on = s.getAttribute('data-index') === index;
        s.classList.toggle('is-selected', on);
        if (on) s.setAttribute('aria-current', 'true');
        else s.removeAttribute('aria-current');
      });
      items.forEach(function (it) {
        var on = it.getAttribute('data-index') === index;
        it.classList.toggle('is-selected', on);
        if (on) it.setAttribute('aria-current', 'true');
        else it.removeAttribute('aria-current');
      });
    }

    function clearOpenState() {
      spots.forEach(function (s) { s.classList.remove('is-open'); });
    }

    spots.forEach(function (spot) {
      var index = spot.getAttribute('data-index');

      spot.addEventListener('focus', function () { select(index); });
      spot.addEventListener('mouseenter', function () { select(index); });

      spot.addEventListener('click', function () {
        if (touch && !spot.classList.contains('is-open')) {
          clearOpenState();
          spot.classList.add('is-open');
          select(index);
          return;
        }
        select(index);
        openLightbox(spot);
      });
    });

    items.forEach(function (item) {
      var index = item.getAttribute('data-index');

      item.addEventListener('focus', function () { select(index); });
      item.addEventListener('mouseenter', function () { select(index); });

      // il testo e' gia' leggibile in chiaro: un solo tocco basta
      item.addEventListener('click', function () {
        select(index);
        openLightbox(item);
      });
    });

    // frecce su e giu' per scorrere l'elenco (o i punti) senza fare
    // affidamento solo sul tasto Tab: navigazione da tastiera sensata
    function arrowNav(list) {
      list.forEach(function (el, i) {
        el.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = list[(i + 1) % list.length];
          else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = list[(i - 1 + list.length) % list.length];
          else if (e.key === 'Home') next = list[0];
          else if (e.key === 'End') next = list[list.length - 1];
          if (next) { e.preventDefault(); next.focus(); }
        });
      });
    }
    arrowNav(items);
    arrowNav(spots);

    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.classList.contains('hh-lightbox__close')) closeLightbox();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) closeLightbox(); });
  }

  /* La veduta del villaggio, a telefono, sta in duecento pixel di altezza:
     leggibile no, ma toccandola si apre grande come una tavola. */
  function apreMappaIntera(root) {
    var img = root.querySelector('.hh-village__img');
    if (!img) return;
    var grande = document.querySelector('[data-hh-map-lightbox]') || document.querySelector('.hh-lightbox');
    if (!grande) return;

    img.style.cursor = 'zoom-in';
    img.setAttribute('role', 'button');
    img.setAttribute('tabindex', '0');
    img.setAttribute('aria-label', 'Open the village map');

    function apri() {
      var foto = grande.querySelector('img');
      var didascalia = grande.querySelector('figcaption');
      foto.src = img.currentSrc || img.src;
      foto.alt = img.alt || '';
      var cap = root.querySelector('.hh-village__caption');
      didascalia.textContent = cap ? cap.textContent.trim() : '';
      grande.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { grande.classList.add('is-open'); });
      grande.querySelector('.hh-lightbox__close').focus();
    }

    img.addEventListener('click', apri);
    img.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); apri(); }
    });
  }

  /* ---------------------------------------------------------------------
     I CARTIGLI NON ESCONO DALLO SCHERMO.

     Segnalato da Diego il 2026-09-12 dal telefono: "escono i quadrati dallo
     schermo". Misurato con diag-cartigli.mjs: il Toll Stone sbordava di 72
     pixel a 390 e di 79 a 320, il Notchwood di 40, il Mill di 50.

     Il perche': il cartiglio si apre centrato sul suo punto, e chi lo tiene
     dentro erano due classi (--apre-dx, --apre-sx) assegnate nel Liquid in
     base alla POSIZIONE IN PERCENTUALE del punto sulla mappa. Ma un cartiglio
     e' largo in pixel, non in percentuale: su una mappa da 340 pixel il
     centro di un cartiglio da 220 sta fuori anche quando il punto e' al 20%.
     Con le percentuali non si indovina: va misurato.

     Qui si misura, una volta al caricamento e a ogni ridimensionamento, e si
     scrive lo scostamento in una variabile CSS. Si puo' fare a cartiglio
     chiuso: l'opacita' e' zero ma il posto e le misure sono gia' quelli.
     --------------------------------------------------------------------- */
  function sistemaCartigli(root) {
    var MARGINE = 10;
    root.querySelectorAll('.hh-spot').forEach(function (punto) {
      var card = punto.querySelector('.hh-spot__card');
      if (!card) return;
      card.style.setProperty('--hh-shift', '0px');
      var r = card.getBoundingClientRect();
      if (r.width < 4) return;
      var dx = 0;
      if (r.left < MARGINE) dx = MARGINE - r.left;
      else if (r.right > window.innerWidth - MARGINE) dx = (window.innerWidth - MARGINE) - r.right;
      /* Se il cartiglio e' piu' largo dello schermo, spostarlo non basta e
         inseguire il bordo lo farebbe ballare: lo si lascia dove sta e lo
         stringe il CSS con la sua max-width in vw. */
      if (r.width > window.innerWidth - MARGINE * 2) dx = 0;
      if (dx) card.style.setProperty('--hh-shift', Math.round(dx) + 'px');
    });
  }

  function boot() {
    document.querySelectorAll('[data-hh-map]').forEach(function (root) {
      init(root);
      apreMappaIntera(root);
      sistemaCartigli(root);

      var attesa = null;
      window.addEventListener('resize', function () {
        clearTimeout(attesa);
        attesa = setTimeout(function () { sistemaCartigli(root); }, 150);
      }, { passive: true });

      /* Le figure arrivano dopo il primo calcolo e cambiano l'altezza della
         mappa, quindi anche la posizione dei punti: si rimisura quando la
         scena e' davvero arrivata. */
      var scena = root.querySelector('.hh-village__img, img');
      if (scena && !scena.complete) scena.addEventListener('load', function () { sistemaCartigli(root); });
      window.addEventListener('load', function () { sistemaCartigli(root); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
